import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { LocalStorage, MenuItemsAccess } from 'src/app/appCommon/Enums/enum';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { AccessControlService } from 'src/app/appServices/CommonService/access-control.service';
import { DefineService } from 'src/app/appServices/DefineService/define-service';
import { PiteamService } from 'src/app/appServices/DefineService/piTeam-service';
import { StandardProcessService } from 'src/app/appServices/DefineService/standardProcess-service';
import { DownloadHelperService } from 'src/app/appServices/DownloadHelperService/download-helper.service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ObservableService } from 'src/app/appServices/ObservableService/observable.service';
import { ToasterService } from 'src/app/appServices/ToasterService/toaster.service';

@Component({
  selector: 'app-standard-process',
  templateUrl: './standard-process.component.html',
  styleUrls: ['./standard-process.component.scss'],
})
export class StandardProcessComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  pageNumber:number = 1;
  rows:number = 15;
  sortOrder:string = 'Asc';
  sortCol:string = '';
  filterVal:string = '';
  searchField:string = '';
  showProgressSpinner: boolean = false;
  noRecordBool!: boolean;
  @Output() totalRecords:number = 0;
  @Output() standardProcessGrid: any = [];
  cols: any;

  standerdProcessBool:boolean = false;
  FacilityName: string = '';
  facilityKey: string | null='';
  UId: string | null = '';
  RoleName: string | null = '';
  roleAccessResult:Array<any> = [];
  isAccessReadWrite:boolean = false;
  isAccessRead: boolean = false;
  implementationName!:string;
  implementationBool:boolean = false;
  fileUploadBool:boolean = false;
  getFileUploadStandardProcessArray:any = [];
  fileUploadName:string = "Uploaded Document EMS";
  unique_Id:number | string = '';
  private subscription: Subscription[] = [];
  roleForFacility: any;
  editScreen: any;
  specBool: boolean = false;
  crossSearchBool: boolean = false;

  constructor(public standardProcessService: StandardProcessService,
    private defineService: DefineService, public PiTeamService: PiteamService,
    private helperService: HelperService, private toastService: ToasterService,
    private messageService: MessageService, private accessControlService: AccessControlService,
    private Observable:ObservableService,private downloadHelper: DownloadHelperService,
    private authService: AuthService) { }
  ngOnInit(): void { 
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.roleForFacility = this.authService.roleForFacility();
    // this.getAllFacilities()
  }

  getAllFacilities() {
    this.showProgressSpinner = true;
    let data = {
      Take: this.rows,
      Skip: this.rows * this.pageNumber - this.rows,
      Sort: {
        FieldName: this.sortCol,
        Order: this.sortOrder,
      },
      Filter: {
        field: '',
        operator: '',
        value: this.searchField,
        logic: '',
        filters: [],
      },
      searchString: this.searchField,
      PageNumber: this.pageNumber,
      serviceType: [],
      roleIDs: [],
    };

    var model = {
      request: data,
      roleName:this.RoleName,
      userId: this.UId,
      System: '',
      Facility: ''
    }

    this.subscription.push(
    this.defineService.GetAllFacilities(model).subscribe({
      next: (res: any) => {
        if (res.data.length == 0) {
          this.noRecordBool = true;
        } else {
          this.noRecordBool = false;
        }
        if (res.data) {
          this.standardProcessGrid = res.data;                                                                                                                               
          this.totalRecords = res.Total;
        }
        this.showProgressSpinner = false;
        this.PiTeamService.currentDateTime();

        const accessData = this.accessControlService.checkAccess( MenuItemsAccess.StandardProcessRead, MenuItemsAccess.StandardProcessReadWrite);
        this.isAccessRead = accessData.isAccessRead;
        this.isAccessReadWrite = accessData.isAccessReadWrite;

      },
      error: (err: any) => {
      },
    })
    );
  }

  showStanderdProcess($event:any){
    // this.standerdProcessBool = true;
    this.FacilityName = $event.facilityName;
    this.facilityKey =  $event.facilityId;
    localStorage.setItem("facilityKey", $event.facilityId);
  }
  showEMS(implentationType:string){
    this.defineService.PassingSearchFacility(this.searchField, false);
  this.standardProcessService._routeToComponent('EMS',this.facilityKey,implentationType);
}
showInpatient(implentationType:string){
  this.defineService.PassingSearchFacility(this.searchField, false);
  this.standardProcessService._routeToComponent('Inpatient',this.facilityKey,implentationType);
}
showTriage(implentationType:string){
  this.defineService.PassingSearchFacility(this.searchField, false);
  this.standardProcessService._routeToComponent('Triage/Walk-In',this.facilityKey,implentationType);
}

BackToCases(){
  this.standerdProcessBool = false;
}

  lazyLoadSchedulesForSpec(event: any) {
    if (event != undefined) {
      this.defineService.GetSearchFacility().pageTypeBool ? '' : this.defineService.PassingSearchFacility(this.searchField, false);
      this.rows = event.rows;
      this.pageNumber = event.first / this.rows + 1;
      this.sortOrder =
        event.multiSortMeta == undefined || event.multiSortMeta[0].order == 1
          ? 'ASC'
          : 'DESC';
      this.sortCol = event.multiSortMeta == undefined ? 'FacilityName' : event.multiSortMeta[0].field;
      this.filterVal = event.filters.global == undefined ? '' : event.filters.global.value;
      this.searchField = this.defineService.GetSearchFacility().passedFacility;
      this.defineService.PassingSearchFacility(this.searchField, false);
      this.searchField.length > 0 ? this.crossSearchBool = true : this.crossSearchBool =  false;
      this.getAllFacilities();
    }
  }

  async applyFilterGlobal($event: any, stringVal: any) {
    const inputValue = ($event.target as HTMLInputElement).value;
    this.dt = await this.defineService.getDtTable();
    this.dt!.filterGlobal(inputValue, stringVal);
    if(inputValue !== ''){
      this.crossSearchBool = true;
    }else{
    this.crossSearchBool = false;
    }
  }
  clearSearchField() {
    this.crossSearchBool = false;
    this.searchField = '';
    this.getAllFacilities();
  }
  CancelImplementation(){
    this.implementationBool = false;
  }

  async ViewDownloadedDocument(name:string,workflow_type:number){
    this.showProgressSpinner = true;
    if(name == 'ems'){
      this.fileUploadName = "Uploaded Document EMS";
    }else if(name == 'triage'){
      this.fileUploadName = "Uploaded Document Triage/Walk-In";
    }else{
      this.fileUploadName = "Uploaded Document Inpatient";
    }
    try {
      this.getFileUploadStandardProcessArray = await (await this.downloadHelper.GetViewDownloadedDocument(this.facilityKey,workflow_type, this.implementationName)).toPromise();
        this.showProgressSpinner = false;
        this.fileUploadBool = true;
    } catch (error) {
        this.showProgressSpinner = false;
      console.error('Error fetching data:', error);
    }
  }
  CancelDownloadedDocument(){
    this.fileUploadBool = false;
  }
  showDownloadDocument(index:number,type:string, fileName: string){
    const $event={
      fileName: fileName,
      index: index,
      type: type
    }
    this.downloadHelper.showDownloadDocument($event, this.getFileUploadStandardProcessArray);
  }

  DeleteDownloadDocument(unique_Id:number){
    this.unique_Id = unique_Id;
    this.messageService.clear();
      this.messageService.add({
        key: 'c',
        sticky: true,
        severity: 'custom',
        summary: 'Are you sure you want to delete?',
      });
  }
  OnConfirm() {
    this.showProgressSpinner = true;
    if(this.unique_Id){
      
      this.standardProcessService.DeleteFileUploadStandardProcess(this.unique_Id).subscribe({
        next: (res: any) => {
          this.showProgressSpinner = false;
          this.getFileUploadStandardProcessArray.forEach((item:any,index:any)=>{
            if(item.qfs_Id == this.unique_Id){
              this.getFileUploadStandardProcessArray.splice(index, 1)
            }
          })
          this.toastService.message('File Delete Successfuly.');
        },
        error: (err: any) => {
        },
      });
    }
    this.messageService.clear();
  }

  OnReject() {
    this.messageService.clear();
  }

  ngOnDestroy() {
    if(this.subscription.length != 0){
      this.subscription.forEach((i:any)=>{
        i.unsubscribe();
      })
    }
    
    Object.getOwnPropertyNames(this)
    .filter(propName => Array.isArray((<any>this)[propName]))
    .forEach(propName => (<any>this)[propName] = []);

  }
}

